import React, { useState } from 'react';
import { PrimaryButton } from '@fluentui/react';
import { AccessGroupsViewModal } from './AccessGroupsViewModal';

export const UserAccessGroupsView = () => {
  const [visible, setVisible] = useState(false);

  const _onClick = () => {
    setVisible(true);
  };

  return (
    <>
      <PrimaryButton
        iconProps={{
          iconName: 'Add',
        }}
        text="New Pool"
        onClick={_onClick}
      />
      <AccessGroupsViewModal
        isOpen={visible}
        onClose={() => setVisible(false)}
      />
    </>
  );
};
